/*
 * Queens Play — auto-scroll carousels.
 * Ports initAutoCarousel from Phase-2 mockup qp-mockup.js. Any element with
 * [data-auto-carousel] auto-advances one card width every 4s IFF the element
 * is scrollable horizontally (skips desktop grid mode where scrollWidth ≈
 * clientWidth). User touch / pointer / wheel pauses the tick for 6s.
 *
 * Bound sections (Liquid):
 *   .qp-pb-grid       — THE PLAYBOOK (homepage + PDP reviews)
 *   .qp-also__grid    — PDP MORE ZIP-UPS rail
 *
 * The CSS-media-based mobile scroll-mode switch (grid → flex overflow-x)
 * already lives in qp-base.css / qp-pdp.css — this file only adds the tick.
 * On desktop where scrollWidth <= clientWidth, tick() no-ops.
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var TICK_MS  = 2500;
  var PAUSE_MS = 6000;
  var timers   = [];

  function initAutoCarousel(el) {
    if (!el || el._qpAutoBound) return;
    el._qpAutoBound = true;

    var paused = false;
    var pauseTimer = null;

    function tick() {
      if (paused) return;
      if (el.scrollWidth <= el.clientWidth + 4) return; // grid mode — nothing to scroll
      var cards = el.children;
      var count = cards.length;
      if (count === 0) return;
      // Find the card currently closest to viewport center. Using position
      // rather than a stored index makes us robust to (a) sub-pixel drift
      // where smooth-scroll settles a few px off the target snap point
      // (previously the tick would then re-issue "scroll to max" and waste
      // a full TICK_MS re-settling before the wrap fired — user visible as
      // "card N stuck for twice as long"), and (b) manual user swipes
      // between ticks (we advance from where the user IS, not where we
      // last commanded a scroll).
      var viewportCenter = el.scrollLeft + el.clientWidth / 2;
      var currentIdx = 0, minDist = Infinity;
      for (var i = 0; i < count; i++) {
        var c = cards[i];
        var cCenter = c.offsetLeft + c.offsetWidth / 2;
        var dist = Math.abs(cCenter - viewportCenter);
        if (dist < minDist) { minDist = dist; currentIdx = i; }
      }
      var nextIdx = (currentIdx + 1) % count;
      var target = cards[nextIdx];
      var next = target.offsetLeft + target.offsetWidth / 2 - el.clientWidth / 2;
      var maxScroll = el.scrollWidth - el.clientWidth;
      next = Math.max(0, Math.min(next, maxScroll));
      el.scrollTo({ left: next, behavior: 'smooth' });
    }

    timers.push(setInterval(tick, TICK_MS));

    function pause() {
      paused = true;
      if (pauseTimer) clearTimeout(pauseTimer);
      pauseTimer = setTimeout(function () { paused = false; }, PAUSE_MS);
    }
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
      el.addEventListener(evt, pause, { passive: true });
    });
  }

  function boot() {
    document.querySelectorAll('[data-auto-carousel]').forEach(initAutoCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
